import styled from "styled-components";
import {MEDIA_QUERIES} from "constants/StyleConstants.js";
import {StyleInputRoundIcon} from "../Common/StyleInput";

export const SignInFormInput = styled(StyleInputRoundIcon)`
  @media only screen and (min-width: ${MEDIA_QUERIES.tablet_min_width}) and (max-width: ${MEDIA_QUERIES.tablet_max_width}) {
    width: 600px;
    max-width: 600px;
    height: 65px;
    max-height: 65px;
  }
`;
